import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdTimeline, getEntitiesByFpIdTimelineQueryKey } from '@onefootprint/fetch-dashboard';
import type { GetEntitiesByFpIdTimelineData, UserTimeline } from '@onefootprint/request-types/dashboard';
import { TimelineEventKind } from '@onefootprint/types';
import { useInfiniteQuery } from '@tanstack/react-query';
import useSession from '@/hooks/use-session';
const useEntityTimeline = (id, query, showAllWatchlistChecks) => {
  const $ = _c(21);
  const {
    authHeaders
  } = useSession();
  let t0;
  if ($[0] !== id || $[1] !== query) {
    t0 = getEntitiesByFpIdTimelineQueryKey({
      path: {
        fpId: id
      },
      query
    });
    $[0] = id;
    $[1] = query;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== authHeaders || $[4] !== id || $[5] !== query) {
    t1 = async t2 => {
      const {
        pageParam
      } = t2;
      const excludeKinds = [query?.excludeKinds, "device_insight"].filter(Boolean).join(",");
      const {
        data
      } = await getEntitiesByFpIdTimeline({
        path: {
          fpId: id
        },
        query: {
          ...query,
          excludeKinds,
          cursor: pageParam,
          pageSize: 10
        },
        headers: authHeaders as GetEntitiesByFpIdTimelineData['headers']
      });
      return data;
    };
    $[3] = authHeaders;
    $[4] = id;
    $[5] = query;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = !!id;
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      getNextPageParam: _temp,
      initialPageParam: undefined as undefined | string,
      enabled: t2
    };
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = useInfiniteQuery(t3);
  let infiniteQuery;
  let infiniteQueryData;
  if ($[11] !== t4) {
    ({
      data: infiniteQueryData,
      ...infiniteQuery
    } = t4);
    $[11] = t4;
    $[12] = infiniteQuery;
    $[13] = infiniteQueryData;
  } else {
    infiniteQuery = $[12];
    infiniteQueryData = $[13];
  }
  let t5;
  if ($[14] !== infiniteQueryData?.pages || $[15] !== showAllWatchlistChecks) {
    const allEvents = infiniteQueryData?.pages.flatMap(_temp2);
    t5 = showAllWatchlistChecks ? allEvents : onlyFirstWatchlistCheck(allEvents || []);
    $[14] = infiniteQueryData?.pages;
    $[15] = showAllWatchlistChecks;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const data_0 = t5;
  const t6 = infiniteQueryData?.pages[0]?.meta.count;
  let t7;
  if ($[17] !== data_0 || $[18] !== infiniteQuery || $[19] !== t6) {
    t7 = {
      ...infiniteQuery,
      data: data_0,
      count: t6
    };
    $[17] = data_0;
    $[18] = infiniteQuery;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};

/** Filter out all except the very first watchlist check event. All others will be rendered in a drawer */
const onlyFirstWatchlistCheck = (allEvents: UserTimeline[]) => {
  const events: UserTimeline[] = [];
  allEvents.forEach(event => {
    const isWatchlistCheck = event.event.kind === TimelineEventKind.watchlistCheck;
    const alreadyHasWatchlistCheck = events.some(e => e.event.kind === TimelineEventKind.watchlistCheck);
    if (isWatchlistCheck && alreadyHasWatchlistCheck) {
      // Skip all but the first watchlist check event
      return;
    }
    events.push(event);
  });
  return events;
};
export default useEntityTimeline;
function _temp(lastPage) {
  return lastPage?.meta.next;
}
function _temp2(page) {
  return page?.data ?? [];
}